import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

// store
import { Store } from '@ngrx/store';

// models
import { AppState } from '../models/app-state.interface';
import { take } from 'rxjs/operators';
import { panelDecrement, panelIncrement, panelSet } from '../reducers/panel.reducer';

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  private _routePathArrABC: Array<String> = [];
  // rename to ccd
  private _routePathArrCCD: Array<String> = [];
  private _activeRoutes = [];
  private _amendRoutes: Array<String> = [];

  constructor(
    private _appStore: Store<AppState>,
    private _router: Router
  ) { }

  // events for updating booking panel

  goToPanel(value: string) {
    if (value === 'next') {
      this._appStore.dispatch(panelIncrement());
    } else if (value === 'prev') {
      this._appStore.dispatch(panelDecrement());
    }
  }

  goToPanelByPath(value: string) {
    const ind = this.getUrlIndex(value);
    this._appStore.dispatch(panelSet({ payload: (ind + 1) }));
  }

  goToPanelByIndex(value) {
    this._appStore.dispatch(panelSet({ payload: value }));
  }

  goToBookingSwitcher(product: string, path: string, data?: any, dataType?: any) {
    const redirectingTo = path;
    this._router.navigate(['/redirectingTo'],
      { queryParams: { redirectToPath: redirectingTo, bookingProduct: product, data: JSON.stringify(data), d2d: dataType } });
  }

  generatePaths(product, departureAirportCode?, isHubdropBooking?, airline?) {

    this._activeRoutes = [];
    this._routePathArrABC = [];
    // rename to ccd
    this._routePathArrCCD = [];

    for (let i = 0; i < this._router.config.length; i++) {
      if (typeof this._router.config[i].children !== 'undefined' && this._router.config[i].children.length !== 0) {

        const thisRoute = this._router.config[i];
        const thisRouteChildren = this._router.config[i].children;
        for (let r = 0; r < thisRouteChildren.length; r++) {
          if (thisRoute.path === 'abc') {
            const val = thisRouteChildren[r].path;
            if (val !== '') {
              this._routePathArrABC.push(val);
            }
          } else if (thisRoute.path === 'ccd') {
            const val = thisRouteChildren[r].path;
            if (val !== '') {
              // rename to ccd
              this._routePathArrCCD.push(val);
            }
          }
        }
      }
    }

    if (product !== 'abc' || departureAirportCode !== 'ZRH' || airline !== 'LX') {
      this._routePathArrABC = this._routePathArrABC.filter(route => route !== 'collection-post-office');
    }

    const bookingTypeAmend = this.getState(this._appStore).bookingReducer.bookingDetails.bookingType

    if (bookingTypeAmend === 'amend' && !isHubdropBooking) {
      this._routePathArrABC = this._routePathArrABC.filter(route => route !== 'collection-post-office');
    }

    if (product === 'abc' && airline === 'LX' && departureAirportCode === 'ZRH' && isHubdropBooking) {
      this._routePathArrABC = this._routePathArrABC.filter(route => route !== 'collection-time');
    }

    if (product === 'abc') {
      this._activeRoutes = this._routePathArrABC;
    } else {
      // rename to ccd
      this._activeRoutes = this._routePathArrCCD;
    }

    function uniq(a) {
      return Array.from(new Set(a));
    }

    this._activeRoutes = uniq(this._activeRoutes);

  }

  generatePathsForAmend(product, paths) {

    this._activeRoutes = [];
    this._routePathArrABC = [];
    // rename to ccd
    this._routePathArrCCD = [];

    if (product === 'abc') {
      for (const item of paths) {
        this._routePathArrABC.push(item);
      }
      this._activeRoutes = this._routePathArrABC;
    } else {
      for (const item of paths) {
        // rename to ccd
        this._routePathArrCCD.push(item);
      }
      this._activeRoutes = this._routePathArrCCD;
    }

  }

  setPathsForAmends(type, isHubdropBooking?) {
    // check product type
    // console.log('route type', type)
    this._amendRoutes = [];

    if (type === 'collection-location') {
      this._amendRoutes.push('collection-location');
      if (isHubdropBooking) {
        this._amendRoutes.push('collection-post-office');
      } else {
        this._amendRoutes.push('collection-time');
      }
      this._amendRoutes.push('payment');
    } else if (type === 'delivery-location') {
      this._amendRoutes.push('delivery-location');
      this._amendRoutes.push('delivery-time');
      this._amendRoutes.push('payment');
    } else if (type === 'passengers') {
      this._amendRoutes.push('passengers');
    } else if (type === 'bags') {
      this._amendRoutes.push('passengers');
    } else if (type === 'collection-time') {
      this._amendRoutes.push('collection-time');
      this._amendRoutes.push('payment');
    } else if (type === 'delivery-time') {
      this._amendRoutes.push('delivery-time');
      this._amendRoutes.push('payment');
    } else if (type === 'collection-post-office') {
      this._amendRoutes.push('collection-post-office');
      this._amendRoutes.push('payment');
    } else if (type === 'booker') {
      this._amendRoutes.push('payment');
    } else if (type === 'payment' || type === 'payment-required') {
      this._amendRoutes.push('payment');
    }

    return this._amendRoutes;

  }

  getURLPath(value, path) {
    // check product type
    // console.log('active routes ', this._activeRoutes);
    let pathValue;
    for (let p = 0; p < this._activeRoutes.length; p++) {
      if ((value - 1) === p) {
        pathValue = '/' + path + '/' + this._activeRoutes[p];
      }
    }

    return pathValue;
  }

  getUrlIndex(path) {

    let pathIndex;
    for (let p = 0; p < this._activeRoutes.length; p++) {
      if (path === this._activeRoutes[p]) {
        pathIndex = p;
      }
    }
    return pathIndex;
  }

  // get store state
  getState(store: Store<AppState>): AppState {
    let state: AppState;
    store.pipe(take(1))
      .subscribe(s => state = s);
    return state;
  }

}
